import axios from "axios";
import ConnUrls from '../Connections/ConnectURL'

// רישום מכשיר של האפליקציה לקבלת push (server/_routers/appPushRouter.js)
const registerDevice = async (obj) => {
    let dFromF = await axios.post(ConnUrls.ApiUrl + "push/register", obj);
    return (dFromF.data);
}

export default {
    registerDevice
};
